"use server";

/**
 * Server actions de la vista overview (/pro) — aceptar/rechazar una solicitud
 * entrante. Patrón canónico: requireRole → getDb → SERVICIO de dominio.
 */
import { getDb } from "@/db/client";
import { acceptBooking, cancelBooking } from "@/db/domains/booking/booking.service";
import {
  markRead as markNotificationRead,
  markAllRead as markAllNotificationsRead,
} from "@/db/domains/notifications/notifications.service";
import { requireRole } from "@/lib/auth/server";
import { assertTherapistOwnsBooking } from "@/lib/auth/ownership";
import type { Locale } from "@/lib/mock";

export async function acceptBookingAction(input: {
  locale: Locale;
  bookingId: string;
}): Promise<{ ok: boolean }> {
  const user = await requireRole("therapist", input.locale);
  const db = await getDb();
  await assertTherapistOwnsBooking(db, input.bookingId, user.userId);
  await acceptBooking(db, input.bookingId, user.userId);
  return { ok: true };
}

export async function declineBookingAction(input: {
  locale: Locale;
  bookingId: string;
}): Promise<{ ok: boolean }> {
  const user = await requireRole("therapist", input.locale);
  const db = await getDb();
  await assertTherapistOwnsBooking(db, input.bookingId, user.userId);
  await cancelBooking(db, {
    bookingId: input.bookingId,
    cancelledBy: "therapist",
    actorId: user.userId,
  });
  return { ok: true };
}

// ─── Bandeja de notificaciones in-app (campana de la nav, fase 5) ──────────

export async function markNotificationReadAction(input: {
  locale: Locale;
  notificationId: string;
}): Promise<void> {
  const user = await requireRole("therapist", input.locale);
  const db = await getDb();
  await markNotificationRead(db, input.notificationId, user.userId);
}

export async function markAllNotificationsReadAction(input: { locale: Locale }): Promise<void> {
  const user = await requireRole("therapist", input.locale);
  const db = await getDb();
  await markAllNotificationsRead(db, user.userId);
}
